export const privacySections = [
    {
        h: "1. Introduction",
        body: [
            {
                p: "Welcome to RapidClick. We are committed to protecting your privacy. This policy explains how we handle your data. RapidClick is designed with a privacy-first approach — the vast majority of your sensitive delivery data never leaves your device.",
            },
        ],
    },
    {
        h: "2. Data We Collect and Store Locally",
        body: [
            {
                p: "Your core automation data is stored entirely locally on your device and is never transmitted to our servers:",
            },
            {
                list: [
                    "Your Settings — pickup and drop distances, area filters, and order preferences",
                    "Order History — price, pickup/drop addresses, and timestamps of orders processed by the app",
                    "Saved Locations — up to 3 recent addresses for the map picker",
                ],
            },
            { p: "We have zero access to this local delivery data." },
        ],
    },
    {
        h: "3. Account and Subscription Data",
        body: [
            {
                p: "To provide a seamless Premium experience across all your devices, we require authentication via Google Sign-In. We securely collect and store:",
            },
            {
                list: [
                    "Your Google Account ID and associated email address",
                    "Your subscription status, trial history, and plan expiration dates",
                ],
            },
            {
                p: "All payments are processed securely by our trusted third-party payment gateway (Razorpay). We do not collect or store your raw credit card numbers or UPI PINs on our servers.",
            },
        ],
    },
    {
        h: "4. Analytics and Security Data",
        body: [
            { p: "To ensure app stability and protect against malicious attacks, we securely collect:" },
            {
                list: [
                    "Basic device information (model, OS version) and Crash reports (via Firebase Crashlytics)",
                    "IP addresses and unique Hardware Device IDs strictly for security, rate-limiting, and preventing API abuse",
                ],
            },
            {
                p: "We do not use this data for advertising or tracking, and we never sell it to third parties.",
            },
        ],
    },
    {
        h: "5. Data We Do NOT Collect",
        body: [
            {
                p: "We never collect your phone number, delivery app credentials (passwords), customer contact details, personal text messages, or GPS location history.",
            },
        ],
    },
    {
        h: "6. Accessibility and Notification Services",
        body: [
            {
                p: "RapidClick requires Android's Accessibility and Notification Listener services strictly to:",
            },
            {
                list: [
                    "Detect incoming order notifications from Rapido and Porter",
                    "Read order details (distances, price, addresses) directly from the order popup screen",
                    "Perform tap actions (Accept or Reject) based on your configured criteria",
                ],
            },
            {
                p: "These services ignore all other apps on your device. We do not read your messages, capture screenshots, or monitor your background activity.",
            },
        ],
    },
    {
        h: "7. Data Security and Your Rights",
        body: [
            {
                p: "Your local data is protected by your device's built-in encryption. Cloud data is secured by Google Firebase. You have the right to request the deletion of your account and associated cloud data at any time by contacting us.",
            },
        ],
    },
    {
        h: "8. Contact Us",
        body: [
            {
                p: "If you have questions about this Privacy Policy, please contact us at hello@rapidclick.in",
            },
        ],
    },
];

export const termsSections = [
    {
        h: "1. Acceptance of Terms",
        body: [
            {
                p: "By downloading or using RapidClick ('the App'), you agree to these Terms of Service. If you do not agree, you must uninstall the App immediately.",
            },
        ],
    },
    {
        h: "2. Description of Service",
        body: [
            {
                p: "RapidClick is a third-party productivity tool designed to automate the acceptance or rejection of delivery orders based on criteria you define. The App utilizes Android's Accessibility and Notification services to interact with supported delivery platforms.",
            },
        ],
    },
    {
        h: "3. Account and Subscriptions",
        body: [
            {
                p: "Following any promotional free trial, continued use of RapidClick requires an active Premium subscription. Subscriptions are securely linked to your Google Account, allowing you to use RapidClick across multiple personal devices.",
            },
            {
                p: "However, you agree not to abuse this feature by sharing your Google Account with multiple other users to bypass subscription fees. We actively monitor for excessive cross-device logins and reserve the right to suspend accounts that violate this policy.",
            },
        ],
    },
    {
        h: "4. Third-Party Platform Disclaimer",
        body: [
            {
                p: "RapidClick is an independent application and is not affiliated with, endorsed by, or sponsored by Rapido, Porter, or their parent companies. You are solely responsible for ensuring your use of RapidClick complies with the terms and policies of your delivery platform. We assume no responsibility for any account suspension, penalties, or consequences arising from platform policy violations.",
            },
        ],
    },
    {
        h: "5. User Responsibilities and Security",
        body: [
            {
                p: "You agree to use the App lawfully and responsibly. You must not use the App while actively operating a vehicle in motion. RapidClick is designed to operate autonomously in the background to ensure your safety.",
            },
            {
                p: "Furthermore, any attempts to hack, reverse-engineer, spam, or bypass our API rate limits and security measures will result in an immediate, permanent hardware-level ban of your device and forfeiture of your subscription.",
            },
        ],
    },
    {
        h: "6. Disclaimer of Warranties",
        body: [
            {
                p: "The App is provided 'as is' and 'as available.' We do not guarantee that the App will function without errors, that it will successfully catch every matching order, or that its use will result in increased earnings. Network latency, device performance, and delivery app updates may affect functionality.",
            },
        ],
    },
    {
        h: "7. Limitation of Liability",
        body: [
            {
                p: "To the maximum extent permitted by law, RapidClick shall not be liable for any indirect, incidental, or consequential damages, loss of income, account suspensions, or traffic violations arising from your use of the App. You use the App entirely at your own risk.",
            },
        ],
    },
    {
        h: "8. Governing Law and Changes",
        body: [
            {
                p: "These Terms are governed by the laws of India. We reserve the right to update these Terms at any time, and continued use of the App constitutes your acceptance of the updated Terms.",
            },
        ],
    },
    {
        h: "9. Contact Us",
        body: [
            {
                p: "For any inquiries regarding these Terms, please contact hello@rapidclick.in",
            },
        ],
    },
];
